export default __webpack_public_path__ + "static/media/client.99feed02.png";